module.exports = __webpack_public_path__ + "@/assets/img/button-creditTeclab.9db9f341.png";